// eslint-disable-next-line no-shadow
var IotOutputFunction;
(function (IotOutputFunction) {
    IotOutputFunction["DOOR"] = "Door";
    IotOutputFunction["LIGHT"] = "Light";
})(IotOutputFunction || (IotOutputFunction = {}));

export { IotOutputFunction };
//# sourceMappingURL=iotOutputFunction.js.map
